const MAX_DOCUMENT_BYTES = 8 * 1024 * 1024;

const ALLOWED_DOCUMENT_TYPES = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'text/plain',
  'text/csv',
]);

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        resolve('');
        return;
      }
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

export function validateDocumentFile(file: File): string | null {
  if (file.size > MAX_DOCUMENT_BYTES) {
    return `File is too large. Maximum size is ${MAX_DOCUMENT_BYTES / (1024 * 1024)} MB.`;
  }
  if (file.type && !ALLOWED_DOCUMENT_TYPES.has(file.type)) {
    return 'File type is not supported. Use PDF, Word, Excel, CSV, text, or an image.';
  }
  return null;
}
